module.exports = __webpack_public_path__ + "static/media/double-down-w.5287ba96.svg";